// @ts-nocheck
import {useEffect} from "react";
import {useLocation} from "react-router-dom";
import {useAuthStore} from "../../../store/useAuth.store";
import LovenNavbar from "./components/LovenNavbar";
import Animalitos from "./pages/Animalitos";
import Home from "./pages/Home";
import Loterias from "./pages/Loterias";

const lotovenContainerCls =
  "fixed top-0 left-0 w-screen h-screen bg-[var(--color-secondary)] z-[var(--z-modal)] flex flex-col";
const contentContainerCls =
  "flex-1 w-full h-[calc(100vh-80px)] overflow-y-auto overflow-x-hidden max-md:h-[calc(100vh-70px)] max-[480px]:h-[calc(100vh-65px)]";

const Lotoven = () => {
  const location = useLocation();
  const user = useAuthStore(state => state.user);

  // Check if user is authorized to view this component
  useEffect(() => {
    const authorizedEmails = ["test01@googletest.com", "test01@gmailtest.com"];
    if (!user || !authorizedEmails.includes(user.email.toLowerCase())) {
      // If user is not authorized, redirect to mobile-login instead of home to avoid loops
      window.location.href = "/mobile-login";
    }
  }, [user]);

  // Render the appropriate page based on the route
  const renderPage = () => {
    const path = location.pathname;

    switch (path) {
      case "/lotoven":
      case "/lotoven/home":
        return <Home />;
      case "/lotoven/animalitos":
        return <Animalitos />;
      case "/lotoven/loterias":
        return <Loterias />;
      default:
        return <Home />;
    }
  };

  // Don't render anything if user is not authorized
  const authorizedEmails = ["test01@googletest.com", "test01@gmailtest.com"];
  if (!user || !authorizedEmails.includes(user.email.toLowerCase())) {
    return null;
  }

  return (
    <div className={lotovenContainerCls}>
      <div className={contentContainerCls}>{renderPage()}</div>
      <LovenNavbar />
    </div>
  );
};

export default Lotoven;
